'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/isNaN.js
// module id = 5629
// module chunks = 0